/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Service} from "../models/service";
import {ServiceService} from "../services/service.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class ServicesPagingResolver implements Resolve<PagedResults<Service>> {

  constructor(
    private mServiceService: ServiceService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<Service>> {
    try {
      return await this.mServiceService.getAllServicesForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Services... Error: " + error, error);
    }
  }

}
